import client from '../client';

const profileApi = {
  get: () => client.get('/profile'),
  update: (payload) => client.put('/profile', payload),
  changePassword: ({ currentPassword, newPassword }) => client.post('/profile/password', { currentPassword, newPassword }),
};

export default profileApi;
